import loginModule from './login.module'
export default loginModule.name
